import React from 'react';
import GeneralSettings from '../../components/settings/GeneralSettings';
import SecuritySettings from '../../components/settings/SecuritySettings';
import NotificationSettings from '../../components/settings/NotificationSettings';
import PageLayout from '../../components/layout/PageLayout';
import ErrorBoundary from '../../components/ui/ErrorBoundary';
import { PAGE_INFO } from '../../constants';
import './Settings.css';

/**
 * Settings Page Component
 * Configuration page for admin dashboard and app settings
 */
const Settings = () => {
  return (
    <ErrorBoundary>
      <PageLayout
        title={PAGE_INFO.SETTINGS.title}
        description={PAGE_INFO.SETTINGS.description}
      >
        <div className="settings-sections">
          <GeneralSettings />
          <SecuritySettings />
          <NotificationSettings />
        </div>
      </PageLayout>
    </ErrorBoundary>
  );
};

export default Settings;
